import { Box, styled } from '@mui/material'

export const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(4),
  gap: theme.spacing(4),
}))

export const PropItemsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  margin: theme.spacing(2),
  gap: theme.spacing(2),
}))

export const PropItem = styled(Box)(({ theme }) => ({
  border: '1px solid #ccc',
  padding: theme.spacing(2),
}))

export const InputGroupWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  padding: '5px',
  height: '100%',
}))

export const AliasesWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: theme.spacing(2),
}))
